import { render, staticRenderFns } from "./margin-card.vue?vue&type=template&id=f0f329dc&scoped=true"
import script from "./margin-card.vue?vue&type=script&lang=js"
export * from "./margin-card.vue?vue&type=script&lang=js"
import style0 from "./margin-card.vue?vue&type=style&index=0&id=f0f329dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f329dc",
  null
  
)

export default component.exports